import { render, staticRenderFns } from "./EasyBackButton.vue?vue&type=template&id=39f65014&scoped=true&"
import script from "./EasyBackButton.vue?vue&type=script&lang=js&"
export * from "./EasyBackButton.vue?vue&type=script&lang=js&"
import style0 from "./EasyBackButton.vue?vue&type=style&index=0&id=39f65014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f65014",
  null
  
)

export default component.exports